import React, { Component } from "react";
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";
import cn from "classnames";
import selectors from "./selectors";
import actions from "../../actions";
import { FormError } from "../../../common/components";
import md5 from "md5";
import { ToastContainer, toast } from "react-toastify";

import { withRouter } from "react-router-dom";
import { LOGGED_ADMIN, paths } from "../../../../../common/constants";

import "react-toastify/dist/ReactToastify.css";

class Login extends Component {
  constructor() {
    super();

    this.state = {
      email: "",
      password: "",
      passcode: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem("x-domain");
  }

  handleSubmit(event) {
    if (event) {
      event.preventDefault();
    }

    const {
      login,
      history: { push },
    } = this.props;
    const { email, password, passcode } = this.state;

    login({ email, password: password, passcode })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          localStorage.setItem(LOGGED_ADMIN, JSON.stringify(data.data));
          push(paths.client.ADMIN_DASHBOARD);
        } else {
          toast.error(data.msg);
        }
      })
      .catch(() => toast.error("Internal Server Error"));
  }

  handleInputChange({ target: { id, value } }) {
    const { resetLoginState, isFormInvalid } = this.props;

    if (isFormInvalid) {
      resetLoginState();
    }

    this.setState({
      [id]: value,
    });
  }

  render() {
    const { email, password, passcode } = this.state;
    const { isSubmitting, isFormInvalid } = this.props;

    const errorBox = isFormInvalid ? (
      <div className="card mb-2">
        <div className="card-body">
          <FormError
            show={isFormInvalid}
            error="Email or password are invalid"
          />
        </div>
      </div>
    ) : null;

    return (
      <div className="app flex-row align-items-center">
        <div className="container">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            style={{ zIndex: 1999 }}
          />
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card-group">
                <div className="card p-4 login-card">
                  <div className="card-body">
                    {errorBox}

                    <form className="login-form" onSubmit={this.handleSubmit}>
                      <p className="text-muted">Sign In to Share Admin.</p>
                      <div className="input-group mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="icon-user" />
                          </span>
                        </div>
                        <input
                          type="text"
                          placeholder="ADMIN ID"
                          id="email"
                          className={cn(
                            "form-control user-email",
                            isFormInvalid ? "is-invalid" : null
                          )}
                          value={email}
                          onChange={this.handleInputChange}
                          required
                        />
                      </div>
                      <div className="input-group mb-4">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="icon-lock" />
                          </span>
                        </div>
                        <input
                          type="password"
                          placeholder="Password"
                          id="password"
                          className={cn(
                            "form-control user-password",
                            isFormInvalid ? "is-invalid" : null
                          )}
                          value={password}
                          onChange={this.handleInputChange}
                          required
                        />
                      </div>
                      <div className="input-group mb-4">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="icon-key" />
                          </span>
                        </div>
                        <input
                          type="text"
                          placeholder="passcode"
                          id="passcode"
                          className={cn(
                            "form-control user-passcode",
                            isFormInvalid ? "is-invalid" : null
                          )}
                          value={passcode}
                          onChange={this.handleInputChange}
                          required
                        />
                      </div>
                      <div className="row">
                        <div className="col-12 text-right">
                          <button
                            className="login-but btn btn-info"
                            disabled={isSubmitting}
                          >
                            LOGIN
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isFormInvalid: PropTypes.bool.isRequired,
  resetLoginState: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default connect(selectors, {
  ...actions.authentication,
})(withRouter(Login));



// WEBPACK FOOTER //
// ./client/react/Admin/views/Login/index.js